import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertField from "../Components/AlertField";
import PatientInfo from "../Components/PatientInfo";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const PrescriptionView = () => {
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const { id } = useParams();
  const { auth } = useAuth();
  const [appointment, setAppointment] = useState({});
  const [prescription, setPrescription] = useState({});
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosPrivate.get(`appointment/${id}`);
        setAppointment(response?.data);
      } catch (err) {
        showAlert("Load Failed.", "warning");
      }
    };

    const fetchPrescription = async () => {
      try {
        const response = await axiosPrivate.get(`prescription/${id}`);
        setPrescription(response?.data);
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else if (err.response.status === 404) {
          showAlert("You have not been prescribed.", "warning");
        } else {
          showAlert("Load Failed", "warning");
        }
      }
    };
    fetchData();
    fetchPrescription();
  }, []);

  const backClick = () => {
    navigate("/list/appointment");
  };

  const download = async () => {
    try {
      //gets the response from server
      const response = await axiosPrivate.post("prescription/pdf", appointment);
      //creates the url from response and makes download prompt open on button click
      const url = window.URL.createObjectURL(new Blob([response.data]));
      //new a element is created
      const link = document.createElement("a");
      //url of pdf is set to href of a element
      link.href = url;
      //sets the value of download attribute to file name
      link.setAttribute("download", "appointment.pdf");
      //link is appended to body and click is called programatically to open prompt
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Download Failed", "warning");
      }
    }
  };

  return (
    <div>
      {auth?.user.roles !== 0 &&
      appointment?.patient_user_id !== auth?.user?.id &&
      appointment?.doctor_id !== auth?.user.id ? (
        <h2 className="text-center py-2 mt-5">
          You Cannot View Prescription of Others.
        </h2>
      ) : (
        <>
          <AlertField alert={alert} />
          <h2 className="text-center py-2">Prescription</h2>

          <div className="mx-5 px-5 bg-light">
            <div className="w-50 px-5 pt-2">
              <PatientInfo appointment={appointment} />
            </div>
            <div className="p-5 pt-2">
              <div>
                <h5 className="text-decoration-underline">
                  Prescribed Medications
                </h5>
              </div>
              <div className="my-2 table-responsive">
                <table className="table table-light table-striped table-hover">
                  <thead>
                    <tr>
                      <th>S.N.</th>
                      <th>Medicine Name</th>
                      <th>Frequency</th>
                      <th>Duration</th>
                      <th>Instruction</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prescription?.medicines ? (
                      prescription?.medicines?.map((medicine, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{medicine.medicine.medicine_name}</td>
                          <td>{medicine.frequency} /day</td>
                          <td>{medicine.duration}</td>
                          <td>{medicine.instruction}</td>
                        </tr>
                      ))
                    ) : (
                      <tr colSpan="5" className="text-center">
                        <td>No medicine prescribed.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <h5 className="mt-4">Additional Note:</h5>
              <p>{prescription?.description}</p>
              <h5 className="mt-5">
                Prescribed By:&nbsp;&nbsp;&nbsp;Dr. {appointment?.doctor_name}
              </h5>
              <div className="w-100 text-center mb-3" style={{ bottom: 0 }}>
                {auth?.user.roles === 2 && (
                  <button className="btn btn-primary me-5" onClick={download}>
                    Download
                  </button>
                )}
                <button className="btn btn-danger" onClick={backClick}>
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PrescriptionView;
